var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-box',{attrs:{"name":"仓库储备排行top10"}},[_c('div',{staticClass:"bar-card",attrs:{"slot":"content"},slot:"content"},[_c('div',{ref:"barRef",staticClass:"chart-container"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }